export const color = {
  primaryPurple: "#7C83FD",
  secondaryPurple: "#96BAFF",
  greenPrimary: "#7DEDFF",
  greenSecondary: "#88FFF7",
  white: "#FFF"
};
